// src/modules/app-views/_apps/appmulti/orders/pages/Init/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useEffect } from 'react';
import { Table } from 'antd';
import { useListContext } from 'components/core/ListProvider';
import useZustand from 'hooks/useZustand';
import appService from 'services/appService';
import {
  customerColumn,
  valueColumn,
  statusColumn,
  orderDateColumn,
} from './components/tableColumns';
import expandedRow from './components/expandedRow';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OrdersInit = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const {
    data,
    loading,
    tableKey,
    pagination,
    handleTableChanges,
    rowSelection,
    buildTableColumns,
    availableTableColumns,
    buildNumberLineColumn,
    buildDocumentCodeColumn,
    buildUpdatedAtColumn,
    buildActionsButtonColumn,
    buildColumnProps,
    query,
    tableComponents,
    hiddenColumns,
    isEditingTable,
    TableFeatures,
  } = useListContext();

  const storedListSettings = useZustand('module', 'listSettings');
  const storedLanguage = useZustand('theme', 'language');

  const sortKey = JSON.stringify(query?.sort || []);
  const searchKey = JSON.stringify(query?.search || {});
  const filterKey = JSON.stringify(query?.filter || {});

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const isMobile = appService.isMobile();

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    buildTableColumns?.([
      buildNumberLineColumn(),
      buildDocumentCodeColumn('order'),
      customerColumn(buildColumnProps),
      valueColumn(buildColumnProps),
      statusColumn(buildColumnProps),
      orderDateColumn(buildColumnProps),
      buildUpdatedAtColumn(),
      buildActionsButtonColumn({
        view: true,
        fitInDropDownMenu: ['archive', 'remove'],
      }),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    storedListSettings?.showNumberOfLine,
    sortKey,
    searchKey,
    filterKey,
    storedLanguage,
    hiddenColumns,
    isEditingTable,
    query?.drawer?.folder,
  ]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <TableFeatures />

      <Table
        key={tableKey}
        scroll={{ x: 'max-content' }}
        bordered
        rowKey="_id"
        size={isMobile ? 'small' : 'large'}
        columns={availableTableColumns}
        dataSource={data || []}
        pagination={pagination}
        className="with-checkbox"
        loading={loading}
        onChange={handleTableChanges}
        rowSelection={rowSelection}
        components={tableComponents}
        expandable={{ expandedRowRender: expandedRow }}
      />
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OrdersInit;
